const translation = {
  tags: {
    education: 'Educație',
    finance: 'Finanţa',
    other: 'Alt',
    travel: 'Călătorie',
    news: 'Știri',
    utilities: 'Utilităţi',
    entertainment: 'Divertisment',
    search: 'Căutare',
    productivity: 'Productivitate',
    design: 'Design',
    videos: 'Videoclipuri',
    medical: 'Medical',
    social: 'Social',
    agent: 'Agent',
    business: 'Afacere',
    weather: 'Vreme',
    image: 'Imagine',
  },
  allTags: 'Toate etichetele',
  searchTags: 'Etichete de căutare',
}

export default translation
